
















































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { JobAlert } from '@/models/jobs/jobalert';
import { JobFilter } from '@/models/jobs/jobfilter';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MapViewJobPager',
  components: {},
})
export default class MapViewJobPager extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private recsPerPage: number = 1;
  private jobAlert: JobAlert = new JobAlert();
  private industry: number = 0;
  private jobSkill: number = 0;
  private candidatePlacementType: string = '';
  private confirmationCheck: boolean = false;

  get isLastPage(): boolean {
    if (this.currentPage === this.pageCount) {
      return true;
    } else {
      return false;
    }
  }

  closeWindow() {
    this.$modal.hide('job-alert-modal');
  }

  showWindow() {
    this.setSearchDetails();
    this.$modal.show('job-alert-modal');
  }

  ///////////////////////////////////////////////

  get isFirstPage(): boolean {
    if (this.currentPage === 1) {
      return true;
    } else {
      return false;
    }
  }

  ///////////////////////////////////////////////

  get pageCount() {
    return this.loadedJobs.length;
  }

  get currentPage() {
    return vxm.jobs.MapViewJobPager.resultPage;
  }

  get loadedJobs(): any[] {
    return vxm.jobs.MapViewJobListing;
  }

  get myJobs(): any[] {
    let jobs = vxm.jobs.Jobs;
    if (jobs) {
      jobs.forEach((job) =>
        job.savedDTTM ? (job.bookmarkStatus = 'A') : (job.bookmarkStatus = 'D'),
      );
      return jobs;
    } else {
      return [];
    }
  }

  ///////////////////////////////////////////////

  getNext() {
    const mvJp = vxm.jobs.MapViewJobPager;
    if (mvJp.resultPage < mvJp.resultCount) {
      mvJp.resultPage++;
    }
  }

  seeMore() {
    const jp = vxm.jobs.JobPager;
    if (vxm.jobs.SearchV2Active) {
      if (jp.resultPage < jp.totalPages) {
        const reqPayload = vxm.jobs.JobListParamsV2;
        reqPayload.pageSize = jp.resultSize;
        reqPayload.pageNumber++;
        vxm.jobs.reloadJobsV2(reqPayload);
      }
    } else {
      if (jp.resultPage < jp.totalPages) {
        const jlp = vxm.jobs.JobListParams;
        jlp.resultPage = jp.resultPage + 1;
        jlp.resultSize = jp.resultSize;
        vxm.jobs.reloadJobs(jlp);
      }
    }
  }

  ///////////////////////////////////////////////

  getPrevious() {
    const mvJp = vxm.jobs.MapViewJobPager;
    if (mvJp.resultPage > 1) {
      mvJp.resultPage--;
    }
  }

  ///////////////////////////////////////////////

  getLast() {
    const mvJp = vxm.jobs.MapViewJobPager;
    mvJp.resultPage = mvJp.totalPages;
  }

  ///////////////////////////////////////////////

  getFirst() {
    const mvJp = vxm.jobs.MapViewJobPager;
    mvJp.resultPage = 1;
  }

  ///////////////////////////////////////////////

  getUserAuthenticationStatus() {
    if (vxm.users.isLoggedIn) {
      this.jobAlert.email = vxm.users.myUserProfile.email;
      this.jobAlert.fullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
    }
  }

  ///////////////////////////////////////////////

  setSearchDetails() {
    this.jobAlert.textCriteria = vxm.jobs.JobListParams.keywords;
    this.jobAlert.jobConfigDetails = JSON.stringify(vxm.jobs.JobListParams);
    this.jobAlert.location = vxm.jobs.JobListParams.location;
    this.jobAlert.companyCode = vxm.jobs.JobListParams.filter.companyCode;
    if (
      vxm.jobs.JobListParams.filter.candidatePlacementTypes &&
      vxm.jobs.JobListParams.filter.candidatePlacementTypes.length > 0
    ) {
      this.candidatePlacementType =
        vxm.jobs.JobListParams.filter.candidatePlacementTypes[0];
    }
    if (
      vxm.jobs.JobListParams.filter.industryTypes &&
      vxm.jobs.JobListParams.filter.industryTypes.length > 0
    ) {
      this.industry = vxm.jobs.JobListParams.filter.industryTypes[0];
    }
    if (
      vxm.jobs.JobListParams.filter.skillTypes &&
      vxm.jobs.JobListParams.filter.skillTypes.length > 0
    ) {
      this.jobSkill = vxm.jobs.JobListParams.filter.skillTypes[0];
    }
    this.getUserAuthenticationStatus();
  }

  //////////////////////////////////////////////////

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get candidatePlacementTypes(): JobFilter[] {
    return vxm.jobs.jfWrapper.candidatePlacementTypes;
  }

  get sortingOptions(): JobFilter[] {
    return vxm.jobs.jfWrapper.sortingOptions;
  }

  get industryVerticals(): JobFilter[] {
    return vxm.jobs.jfWrapper.industryVerticals;
  }

  get datePosted(): JobFilter[] {
    return vxm.jobs.jfWrapper.datePosted;
  }

  get jobSkills(): JobFilter[] {
    return vxm.jobs.jfWrapper.jobSkills;
  }

  //////////////////////////////////////////////////

  validateJobAlert(): boolean {
    if (
      this.confirmationCheck === false ||
      !this.jobAlert.email ||
      !this.jobAlert.fullName ||
      !this.jobAlert.name ||
      !this.jobAlert.textCriteria
    ) {
      this.$wlToastr(
        'error',
        this.$t(this.errorString),
        'Alert Name, Full Name, E-mail, Criteria, and Confirmation Check required!',
      );
      return false;
    } else {
      return true;
    }
  }

  //////////////////////////////////////////////////

  saveJobAlert() {
    if (this.validateJobAlert()) {
      vxm.jobs.createJobAlert(this.jobAlert).then((res) => {
        console.log('Job Alert Respons', res);
        if (res === true) {
          this.$wlToastr(
            'success',
            this.$t(this.successString),
            this.getJobAlertSuccessMessage(),
          );
        }
      });
    }
  }

  getJobAlertSuccessMessage() {
    if (vxm.users.isLoggedIn) {
      return this.$t('jobalert-created-success-message').toString();
    }
    return this.$t('jobalert-created-anon-success-message').toString();
  }

  //////////////////////////////////////////////////

  mounted() {
    this.setSearchDetails();
    if (vxm.jobs.SearchV2Active) {
      //this.recsPerPage = vxm.jobs.JobListParamsV2.pageSize;
    } else {
      //this.recsPerPage = vxm.jobs.JobListParams.resultSize;
    }
  }
}
